<template>
  <div>
    <search-bar :items="searchItems" @search="doSearch">
    </search-bar>

    <div class="card">
      <div flex>
        <div>
          <el-button type="primary" round size="small" icon="el-icon-plus" @click="$open('/doc-po-edit/new', 1000)">New PO</el-button>
        </div>
        <div style="margin-left:20px;padding-top:4px;">
          当前开单汇率:&nbsp;&nbsp;USD/RMB:<strong>{{ usd_rmb_rate }}</strong>&nbsp;USD/HKD:<strong>{{ usd_hkd_rate }}</strong><el-button type="text" style="margin-left:10px;" @click="changeRate">点此设置</el-button>
        </div>
        <el-pagination 
          @size-change="pageSizeChange" 
          @current-change="pageChange" 
          :current-page="currentPage" 
          :page-sizes="[20, 50, 100, 500]" 
          :page-size="pageSize" 
          layout="total, sizes, pager" 
          :total="total" 
          style="text-align:right;"
          flex-box="1">
        </el-pagination>
      </div>
      <table class="normal-table" style="margin-top:10px;">
        <tr>
          <th style="width:88px;">View</th>
          <th style="width:70px;">PO date</th>
          <th style="width:100px;">Entering date</th>
          <th style="width:84px;">PO number</th>
          <th>Company</th>
          <th style="width:70px;">Sales</th>
          <th style="width:70px;">Currency</th>
          <th style="width:62px;">Amount</th>
          <th style="width:78px;">Profit(usd)</th>
          <th style="width:52px;">Status</th>
          <th style="width:60px;">E-R No.</th>
          <th style="width:120px;">Internal remarks</th>
          <th style="width:100px;">Charges(usd)</th>
          <th style="width:40px;">Lock</th>
        </tr>
        <template v-for="item in list">
          <tr :key="item.id" style="background-color:#eae9fe;" v-if="item.is_del == '0'">
            <td v-if="user.role_id>=3 && item.create_oper_id!=user.id">&nbsp;</td>
            <td v-else><a @click="$open(`/po-order-view/${item.id}`, 840)">view</a>&nbsp;|&nbsp;<a @click="$open(`/po-sold-to/${item.id}`, 840)">sold to...</a></td>
            <td>{{ item.doc_date }}</td>
            <td><el-button type="info" style="padding:0;" @click="$open(`/po-order-date/${item.id}`, 800)">Ent</el-button>&nbsp;{{ item.delivery_date_e }}</td>
            <td>PO&nbsp;CYS<span v-if="user.role_id >= 3 && item.create_oper_id!=user.id">{{ item.id }}</span><a v-else @click="$open('/doc-po-edit/' + item.id, 1000)">{{ item.id }}</a></td>
            <td v-if="user.role_id >= 3 && item.create_oper_id != user.id">&nbsp;</td>
            <td v-else style="color:blue;" :title="item.company_name">{{ item.company_name }}</td>
            <td>{{ item.sales_name }}</td>
            <td style="text-align:right;">{{ item.currency }}</td>
            <td style="text-align:right;">{{ item.total_charge | 1000  }}
              <template v-if="item.currency !== 'USD'">
                <br/>(USD{{ item.total_charge_usd }})
              </template>
            </td>
            <td style="text-align:right;">{{ item.profit | 1000  }}</td>
            <td style="padding:0;font-size:14px;">
              <a @click="adminOpen(`/po-order-payment/${item.id}`, 800)">
                <el-tooltip placement="bottom">
                  <div slot="content" v-html="item.pay_content"></div>
                  <i class="el-icon-goods" style="color:#409eff;font-weight:bold;" v-if="item.pay_count > 0 && item.pay_amount == item.total_charge"></i>
                  <i class="el-icon-goods" style="color:#f28500;font-weight:bold;" v-else-if="item.pay_count > 0 && item.pay_amount != item.total_charge"></i>
                  <i class="el-icon-goods" style="color:#424242;font-weight:bold;" v-else></i>
                </el-tooltip>
              </a>
              <a @click="$open(`/order-photo/po/${item.id}`, 800)" style="margin-left:4px;">
                <i class="el-icon-picture" style="color:#409eff;font-weight:bold;" v-if="item.photo_count > 0"></i>
                <i class="el-icon-picture" style="color:#424242;font-weight:bold;" v-else></i>
              </a>
              <span v-if="user.role_id>=3 && item.create_oper_id!=user.id">&nbsp;</span>
              <span v-else>
                <a @click="$open(`/order-file/po/${item.id}`, 800)" style="margin-left:4px;">
                  <i class="el-icon-document" style="color:#409eff;font-weight:bold;" v-if="item.file_count > 0"></i>
                  <i class="el-icon-document" style="color:#424242;font-weight:bold;" v-else></i>
                </a>
              </span>
            </td>
            <td :title="item.e_r_no">{{ item.e_r_no }}</td>
            <td v-if="user.role_id >= 3 && item.create_oper_id != user.id">&nbsp;</td>
            <td v-else :title="item.internal_remarks">{{ item.internal_remarks }}</td>
            <td style="text-align:right;">0</td>
            <td style="padding:0;font-size:14px;text-align:center;">
              <a @click="lock(item)" v-if="user.role_id < 3">
                <i class="iconfont icon-lock" style="color:#409eff;font-weight:bold;" v-if="item.is_locked === '1'"></i>
                <i class="iconfont icon-lock" style="color:#999;font-weight:bold;" v-else></i>
              </a>
            </td>
          </tr>
          <tr :key="item.id" v-else style="color:red;background-color:#eae9fe;">
            <td v-if="user.role_id>=3 && item.create_oper_id!=user.id">&nbsp;</td>
            <td v-else><a @click="$open(`/po-order-view/${item.id}`, 840)">view</a>&nbsp;</td>
            <td>{{ item.doc_date }}</td>
            <td>{{ item.delivery_date_e }}</td>
            <td>PO&nbsp;CYS{{ item.id }}</td>
            <td v-if="user.role_id >= 3 && item.create_oper_id != user.id">&nbsp;</td>
            <td style="color:blue;" v-else :title="item.company_name">{{ item.company_name }}</td>
            <td>{{ item.sales_name }}</td>
            <td style="text-align:right;">{{ item.currency }}</td>
            <td style="text-align:right;">{{ item.total_charge | 1000 }}</td>
            <td style="text-align:right;">{{ item.profit | 1000 }}</td>
            <td style="padding:0;font-size:14px;">
              <a @click="adminOpen(`/po-order-payment/${item.id}`, 800)">
                <el-tooltip placement="bottom">
                  <div slot="content" v-html="item.pay_content"></div>
                  <i class="el-icon-goods" style="color:#409eff;font-weight:bold;" v-if="item.pay_count > 0 && item.pay_amount == item.total_charge"></i>
                  <i class="el-icon-goods" style="color:#f28500;font-weight:bold;" v-else-if="item.pay_count > 0 && item.pay_amount != item.total_charge"></i>
                  <i class="el-icon-goods" style="color:#424242;font-weight:bold;" v-else></i>
                </el-tooltip>
              </a>
              <a @click="$open(`/order-photo/po/${item.id}`, 800)" style="margin-left:4px;">
                <i class="el-icon-picture" style="color:#409eff;font-weight:bold;" v-if="item.photo_count > 0"></i>
                <i class="el-icon-picture" style="color:#424242;font-weight:bold;" v-else></i>
              </a>
              <span v-if="user.role_id>=3 && item.create_oper_id!=user.id">&nbsp;</span>
              <span v-else>
                <a @click="$open(`/order-file/po/${item.id}`, 800)" style="margin-left:4px;">
                  <i class="el-icon-document" style="color:#409eff;font-weight:bold;" v-if="item.file_count > 0"></i>
                  <i class="el-icon-document" style="color:#424242;font-weight:bold;" v-else></i>
                </a>
              </span>
            </td>
            <td :title="item.e_r_no">{{ item.e_r_no }}</td>
            <td v-if="user.role_id >= 3 && item.create_oper_id != user.id">&nbsp;</td>
            <td v-else :title="item.internal_remarks">{{ item.internal_remarks }}</td>
            <td style="text-align:right;">0</td>
            <td>&nbsp;</td>
          </tr>
          <tr v-if="showDetails" v-for="d in item.details" :key="item.id + '_' + d.id">
            <td colspan="3" style="color:blue;"><a @click="$open(`/product/${d.product_id}/details`)">{{ d.part_no }}</a></td>
            <td colspan="2">{{ d.description }}</td>
            <td colspan="2">{{ d.brand }}</td>
            <td colspan="2">
              <div v-if="d.qty_bb > 0">bb: {{ d.qty_bb }}</div>
              <div v-if="d.qty_hk > 0"><span style="color:#f28500">hk</span> stock: {{ d.qty_hk }}</div>
              <div v-if="d.qty_sz > 0"><span style="color:#f28500">sz</span> stock: {{ d.qty_sz }}</div>
            </td>
            <td colspan="2">{{ item.currency }}<span style="color:blue;">{{ d.price }}</span></td>
            <td colspan="3" style="background-color:#ffd6b1;" v-if="(user.role_id < 3 || item.create_oper_id == user.id) && d.solds && d.solds.length > 0">
              <div v-for="s in d.solds" :key="s.sold_id">inv {{ s.type }}:{{ s.qty }} USD<span style="color:red;">{{ s.price }}</span> {{ s.company }}</div>
            </td>
            <td colspan="3" v-else>&nbsp;</td>
          </tr>
          <tr :key="item.id + '_d'" v-if="showDetails">
            <td colspan="14">
              &nbsp;
            </td>
          </tr>
        </template>
        <tr v-if="list.length > 0">
          <td colspan="6" style="text-align:right;">TOTAL:</td>
          <td style="text-align:right;">USD</td>
          <td style="text-align:right;">{{ totalAmount | 1000 }}</td>
          <td style="text-align:right;">{{ totalProfit | 1000 }}</td>
          <td colspan="5"></td>
        </tr>
      </table>
      <no-data :loading="loading" :list="list"></no-data>
      <el-pagination @size-change="pageSizeChange" @current-change="pageChange" :current-page="currentPage" :page-sizes="[20, 50, 100, 500]" :page-size="pageSize" layout="total, sizes, pager" :total="total" style="text-align:right;"></el-pagination>
    </div>
    <el-dialog title="修改汇率" :visible.sync="rateFormVisible">
      <div>
        USD/RMB: <el-input v-model="rateForm.usd_rmb_rate" style="width:60px;"></el-input>&nbsp;&nbsp;
        USD/HKD: <el-input v-model="rateForm.usd_hkd_rate" style="width:60px;"></el-input>&nbsp;&nbsp;
        *从最近的一张订单开始,后面都是这个汇率
      </div>
      <div style="margin-top:10px;">
        <el-button type="primary" @click="rateFormCommit" :loading="rateFormCommiting" :disabled="!isChanged">Save Changes</el-button>
      </div>
      <div style="margin-top:10px;">
        <div class="table-title">历史记录</div>
        <table class="normal-table">
          <tr>
            <th>#</th>
            <th>USD/RMB</th>
            <th>USD/HKD</th>
            <th>By</th>
            <th>Time</th>
            <th>Start PO No.</th>
          </tr>
          <tr v-for="(item, index) in rateList" :key="item.id">
            <td>{{ index + 1 }}</td>
            <td>{{ item.usd_rmb_rate }}</td>
            <td>{{ item.usd_hkd_rate }}</td>
            <td>{{ item.oper_name }}</td>
            <td>{{ item.oper_time }}</td>
            <td>CYS{{ item.start_no }}</td>
          </tr>
        </table>
        <no-data :loading="false" :list="rateList" :padding="30"></no-data>
      </div>
      <div slot="footer" style="margin-top:10px;">
        <el-button @click="rateFormVisible = false">Close</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import ListFunc from '@/mixins/ListFunc'
import NoData from '@/components/NoData'
import qs from 'qs'
import moment from 'moment'
import NP from 'number-precision'
export default {
  mixins: [ListFunc],
  components: {
    NoData
  },
  data () {
    return {
      sqlcode: 'po_doc_list',
      showDetails: false,
      usd_rmb_rate: 0,
      usd_hkd_rate: 0,
      rateForm: {
        usd_rmb_rate: 0,
        usd_hkd_rate: 0
      },
      rateFormVisible: false,
      rateFormCommiting: false,
      rateList: []
    }
  },
  computed: {
    user () {
      return this.$store.state.user
    },
    totalAmount () {
      let t = 0
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].is_del !== '1') {
          t = NP.plus(t, parseFloat(this.list[i].total_charge_usd || this.list[i].total_charge))
        }
      }
      return t
    },
    totalProfit () {
      let t = 0
      for (let i = 0; i < this.list.length; i++) {
        if (this.list[i].is_del !== '1') {
          t = NP.plus(t, parseFloat(this.list[i].profit))
        }
      }
      return t
    },
    searchItems () {
      return [
        { key: 'company_name', label: 'Comp.name', type: 'input', width: 260 },
        { key: 'sales_id', label: 'Sales', type: 'select', state: 'sales', option_label: 'realname', option_value: 'id', defaultValue: this.user.role_id < 3 ? null : this.user.id, width: 160 },
        { key: 'office', label: 'Office', type: 'select', state: 'office', defaultValue: 'CYS', width: 110 },
        { key: 'id', label: 'PO Number', type: 'input', width: 160 },
        { key: 'part_no', label: 'Part Number', type: 'input', width: 257 },
        { key: 'brand', label: 'Brand', type: 'input', width: 120 },
        { key: 'status', label: 'PO Status', type: 'select', state: 'po_status', width: 160 },
        { key: 'country', label: 'Country', type: 'select', state: 'countries', option_label: 'en', option_value: 'en', width: 160 },
        { key: 'date', label: 'Date', type: 'daterange', placeholder: 'PO Date', defaultValue: [moment().subtract(7, 'days'), moment().endOf('day')] },
        { key: 'e_r_no', label: 'E-R No.', type: 'input', width: 160 },
        { key: 'details', label: 'Details', type: 'checkbox' },
        { key: 'with_docu', label: 'With Docu.', type: 'checkbox' }
      ]
    },
    isChanged () {
      if (!this.rateFormVisible) {
        return false
      }
      if (this.usd_rmb_rate !== this.rateForm.usd_rmb_rate) {
        return true
      }
      if (this.usd_hkd_rate !== this.rateForm.usd_hkd_rate) {
        return true
      }
      return false
    }
  },
  mounted () {
    this.loadRate()
    this.fetchRateHistory()
  },
  methods: {
    loadRate () {
      this.$http.get('/dbapi/sys_settings').then(data => {
        if (data.list.length > 0) {
          this.usd_rmb_rate = data.list[0].po_usd_rmb_rate
          this.usd_hkd_rate = data.list[0].po_usd_hkd_rate
        }
      })
    },
    fetchRateHistory () {
      this.$http.get('/dbapi/po_rate_history').then(data => {
        this.rateList = data.list
      })
    },
    fetchList () {
      if (this.pageSize > 0) {
        this.params.start = (this.currentPage - 1) * this.pageSize
        this.params.limit = this.pageSize
      }
      this.loading = true
      this.$http.get('/dbapi/' + this.sqlcode, {
        params: {
          ...this.params,
          ...this.fixedParams
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(data => {
        this.list = data.list
        this.total = data.total
        if (!this.showDetails) {
          return Promise.resolve({list: []})
        }
        this.params.start = 0
        this.params.limit = 10000
        return this.$http.get('/dbapi/po_doc_details', {
          params: {
            ...this.params,
            ...this.fixedParams
          },
          paramsSerializer: function(params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
          }
        })
      }).then(data => {
        if (data.list.length === 0) {
          return Promise.resolve({list: []})
        }
        let list = this.list.slice()
        let details = data.list
        for (let i = 0; i < list.length; i++) {
          list[i].details = []
          for (let j = 0; j < details.length; j++) {
            if (details[j].doc_id === list[i].id) {
              list[i].details.push(details[j])
            }
          }
        }
        this.list = list
        return this.$http.get('/dbapi/po_sold_list', {
          params: {
            doc_ids: this.list.map(r => r.id)
          },
          paramsSerializer: function(params) {
            return qs.stringify(params, { arrayFormat: 'repeat' })
          }
        })
      }).then(data => {
        this.loading = false
        if (data.list.length > 0) {
          let list = this.list.slice()
          let solds = data.list
          for (let i = 0; i < list.length; i++) {
            for (let j = 0; j < list[i].details.length; j++) {
              list[i].details[j].solds = []
              for (let k = 0; k < solds.length; k++) {
                if (solds[k].po_id === list[i].details[j].id) {
                  list[i].details[j].solds.push(solds[k])
                }
              }
            }
          }
          this.list = list
        }
        this.fetchPays()
      }).catch(() => this.loading = false)
    },
    fetchPays () {
      this.$http.get('/dbapi/po_payment_list', {
        params: {
          order_ids: this.list.map(r => r.id)
        },
        paramsSerializer: function(params) {
          return qs.stringify(params, { arrayFormat: 'repeat' })
        }
      }).then(data => {
        let list = this.list.slice()
        for (let i = 0; i < list.length; i++) {
          if (this.user.role_id < 3 || list[i].create_oper_id == this.user.id) {
            let content = ''
            for (let j = 0; j < data.list.length; j++) {
              if (data.list[j].order_id === list[i].id) {
                content += `Paid ${list[i].currency} ${data.list[j].amount} `
                if (data.list[j].remark) {
                  content += `Remark:${data.list[j].remark} `
                }
                content += `${data.list[j].bank} ${data.list[j].pay_date} by ${data.list[j].sales_name}<br/>`
              }
            }
            content += `Banlance ${list[i].currency} ` + NP.minus(parseFloat(list[i].total_charge), parseFloat(list[i].pay_amount))
            list[i].pay_content = content
          }
        }
        this.list = list
      })
    },
    adminOpen (url, width) {
      this.user.role_id < 3 && this.$open(url, width)
    },
    doSearch (params) {
      this.showDetails = (params.details === '1')
      if (!!params.id) {
        delete params.date_start
        delete params.date_end
      }
      this.search(params)
    },
    lock (item) {
      item.is_locked = item.is_locked === '1' ? '0' : '1'
      this.$http.post('/dbapi/po_doc_lock', {
        id: item.id,
        is_locked: item.is_locked
      })
    },
    changeRate () {
      if (this.user.role_id >= 3) {
        this.$alert('请找管理员修改汇率', '提示')
        return false
      }
      this.rateForm.usd_rmb_rate = this.usd_rmb_rate
      this.rateForm.usd_hkd_rate = this.usd_hkd_rate
      this.rateFormVisible = true
    },
    rateFormCommit () {
      this.rateFormCommiting = true
      this.$http.post('/dbapi/sys_settings_rate_po', this.rateForm).then(data => {
        this.rateFormCommiting = false
        this.usd_rmb_rate = this.rateForm.usd_rmb_rate
        this.usd_hkd_rate = this.rateForm.usd_hkd_rate
        this.$message({
          type: 'success',
          message: '汇率修改成功'
        })
        this.fetchRateHistory()
        // this.rateFormVisible = false
      }).catch(() => this.rateFormCommiting = false)
    }
  }
}
</script>